<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import {Constans} from "../lib/Constants";
    import {reviveSubscription} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let identity;

    let paidTill;
    $: identity && (paidTill = (new Date(identity.spy_paid_till * 1000)).toLocaleDateString());

    let reviveInProgress = false;
    let subscriptionWasRevived = false;
    async function initReviveSubscription() {
        if (reviveInProgress) return;

        reviveInProgress = true;
        const response = await reviveSubscription();

        if (response.status === 'ok') {
            subscriptionWasRevived = true;
            try {
                if (params.changeSpySubscriptionStatus instanceof Function) {
                    params.changeSpySubscriptionStatus(Constans.spySubscriptionStatuses.ACTIVE);
                }
            } catch (err) { console.error(err) }
        }
        reviveInProgress = false;
    }
</script>


<section class="subscription-renewal-block tail">
    <h2 class="subscription-renewal-block__title tail__title">{$_('recoverSubscriptionBlock.title')}</h2>
    <p class="subscription-renewal-block__text tail__text">{@html $_('recoverSubscriptionBlock.description', {
        values: { paidTill }
    })}</p>
    <button on:click={initReviveSubscription} class="button button_shadow subscription-renewal-block__btn">
        <LoadingIcon show={reviveInProgress} height="16" width="16" color="#fff" />
        {$_('recoverSubscriptionBlock.reviveBtnLabel')}
    </button>
</section>